import './space.less'
import { Space } from './space'

export type { SpaceProps } from './space'

export default Space
